import { getBaseReducer } from 'utils';
import actions from './actions';

const initState = {
  ...(getBaseReducer([])),
  entityType: 'schema',
  selectedItem: {},
};

export default function schemaReducer(state = initState, action) {
  switch (action.type) {
    case actions.CLEAR_SCHEMA:
      return {
        ...state,
        data: [],
        selectedItem: {},
        init: false,
      };
    case actions.SORT_SCHEMA:
      return {
        ...state,
        sort: action.sort,
      };
    case actions.FETCH_SCHEMA_SUCCESS:
      return {
        ...state,
        data: action.data,
        init: true,
      };
    case actions.SELECT_SCHEMA_SUCCESS:
      return {
        ...state,
        selectedItem: action.data,
      };
    case actions.CLEAR_SELECTED_SCHEMA:
      return {
        ...state,
        selectedItem: {},
      };
    case actions.SELECT_SCHEMA_FAILURE:
      return {
        ...state,
        selectedItem: { ...action.data, error: true },
      };
    case actions.ADD_SCHEMA_SUCCESS:
      return {
        ...state,
        data: [
          action.selectedItem,
          ...state.data,
        ],
        selectedItem: action.selectedItem,
        view: false,
      };
    case actions.EDIT_SCHEMA_SUCCESS:
      return {
        ...state,
        selectedItem: action.selectedItem,
        view: false,
      };
    case actions.DELETE__SCHEMA:
      return {
        ...state,
        data: action.data.filter((x) => x),
        selectedId: action.selectedId,
      };
    case actions.CHANGE_SCHEMA_VIEW:
      return {
        ...state,
        selectedItem: action.selectedItem || {},
        view: !state.view,
      };
    default:
      return state;
  }
}
